import React from "react";
import "reactjs-popup/dist/index.css";
import { Card, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "./CustomCards.scss";
import "../../dashboard/CloudDiscovery/CloudConfiguration.scss";
const CustomCards = ({ cardData, col }) => {
  const navigate = useNavigate();
  return (
    <>
      <Row>
        {cardData.map((item, index) => (
          <Col
            className={col ? "mb-4" : "custom-col mb-4"}
            xs={12}
            sm={6}
            md={6}
            xl={col}
            lg={3}
            key={index}
          >
            <Card
              onClick={() => navigate(item.link)}
              className="pt-3 cursor_pointer hover-card"
            >
              <div className="d-flex justify-content-between align-items-start mb-2 mr-2">
                {item.imageURL && (
                  <LazyLoadImage
                    src={item.imageURL}
                    alt={item.title}
                    height={40}
                    width={40}
                    effect="blur"
                    className="ms-3 rounded-start" 
                  />
                )}
                {(item.beta || item.commingsoon) && (
                  <div className="ms-5">
                    {item.beta && (
                      <span className="cloud-discovery-beta-tag me-2">
                        Beta
                      </span>
                    )}
                    {item.commingsoon && (
                      <span className="cloud-discovery-coming-soon-tag me-2">Coming Soon</span>
                    )}
                  </div>
                )}
              </div>
              <Card.Body className="ff-pam">
                {item.imageComponent && (
                  <div
                    className="icon-cards-circle"
                    style={{ backgroundColor: item.color }}
                  >
                    {item.imageComponent}
                  </div>
                )}
                <Card.Title className="fs-14px">{item.title}</Card.Title>
                <Card.Text className="fs-12px">{item.description}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </>
  );
};
export default CustomCards;
